import { render, staticRenderFns } from "./diyahuilu.vue?vue&type=template&id=70f2a8e3&scoped=true&"
import script from "./diyahuilu.vue?vue&type=script&lang=js&"
export * from "./diyahuilu.vue?vue&type=script&lang=js&"
import style0 from "./diyahuilu.vue?vue&type=style&index=0&id=70f2a8e3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f2a8e3",
  null
  
)

export default component.exports